export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 },
  }),
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

export const lineMask = {
  hidden: { y: "115%", rotate: 2.5 },
  show: (i = 0) => ({
    y: "0%",
    rotate: 0,
    transition: { duration: 1.05, ease: [0.22, 1, 0.36, 1], delay: 0.18 + i * 0.1 },
  }),
};

export const viewportOnce = { once: true, amount: 0.15 };

export const onSpotMove = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};